'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*jshint esversion: 6 */
// Theme JS here
function sameHeight(selector) {
  var height = 0;
  var maxHeight, result;
  jQuery(selector).each(function () {
    result = jQuery(this);
    // If the height is greater than the last checked value
    if (result.outerHeight() > height) {
      // Set the height we'll use to the greater value
      maxHeight = this;
      height = result.outerHeight();
    }
  });

  // apply the height to each result
  jQuery(selector).css('height', height);
}

function dateToString(date) {
  var count = (date.match(/-/g) || []).length;
  if (count == 1) {
    date = date + '-01'; // append the day value..
  }
  var d = new Date(date);
  var strArray = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var day = d.getUTCDate() + 1;
  // @todo: figure out why I need to do this..
  var month = strArray[d.getUTCMonth()];
  var year = d.getUTCFullYear();
  var string = count == 1 ? month + ', ' + year : month + ' ' + day + ', ' + year;
  return string;
}

objectFitVideos();

function formatDate(date) {
  var d = void 0;

  /* if (typeof date === 'undefined') {
    d = new Date();
  } else { */
  d = new Date(date);
  /* } */
  var month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return [year, month, day].join('-');
}

function monthFormatDate(date) {

  var d = void 0;
  /* if (typeof date === 'undefined') {
    d = new Date();
  } else { */
  d = new Date(date);
  /* } */
  var month = '' + (d.getMonth() + 1),
      year = d.getFullYear();

  if (month.length < 2) month = '0' + month;

  return [year, month].join('-');
}

(function ($) {
  // close the mega menu if you click somewhere in the body of the site
  $('main').on('click', function () {
    $('.c-mega-menu__close').click();
  });

  $(document).keyup(function (e) {
    if (e.keyCode === 27) {
      $('.c-mega-menu__close').click();
    }
  });

  var navLink = $('.nav-link');
  navLink.on('click', function () {
    $(this).on('shown.bs.tab', function () {
      var menuColumns = $('.restaurant__menu--columns');
      menuColumns.masonry({
        transitionDuration: 0
      });
    });
  });

  $(window).on('load', function () {
    sameHeight('.cards .owl-item .card');
    sameHeight('.card.offer h2');
    sameHeight('.offers .owl-item .card');
    sameHeight('.offers .owl-item .card h2');
    sameHeight('.card--hotel-room h2');
  });

  $('[data-fancybox="gallery"]').fancybox({
    buttons: ["zoom",
    //"share",
    //"slideShow",
    //"fullScreen",
    //"download",
    //"thumbs",
    "close"],
    loop: true,

    afterLoad: function afterLoad(instance, current) {
      current.$image.attr('alt', current.opts.$orig.find('img').attr('alt'));
    }

  });

  // Vimeo JS play and pause button 
  // vimeo player - hero
  $('.video__controls--play, .video__controls--pause').on('click', function () {
    $('.video__controls button').toggleClass('hide');

    if ($(this).hasClass("video__controls--pause")) {
      $(this).prev().focus();
    }
    if ($(this).hasClass("video__controls--play")) {
      $(this).next().focus();
    }
  });

  if ($('.vimeo_media .video__wrapper').length) {
    var iframe = $('.vimeo_media iframe')[0];

    if (Vimeo) {
      var player = new Vimeo.Player(iframe);

      // bind events
      var playButton = $(".video__controls--play")[0];
      playButton.addEventListener("click", function () {
        player.play();
      });

      var pauseButton = $(".video__controls--pause")[0];
      pauseButton.addEventListener("click", function () {
        player.pause();
      });
    }
  }

  $('.play-button').on('click', function () {
    $(this).parent('.vimeo_media').find('.video__wrapper').css('z-index', '1');
    var video_id = $(this).parent('.vimeo_media').find('.video__wrapper').attr('data-video-id');
    var iframe = $(this).parent('.vimeo_media').find('iframe');
    if (video_id) {
      $(this).parent('.vimeo_media').addClass('play-video');
      var video_markup = '<iframe src="https://player.vimeo.com/video/' + video_id + '?autoplay=1" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>';
      $(this).parent('.vimeo_media').find('.video__wrapper').html(video_markup);
    } else if (iframe) {
      iframe.attr('src', iframe.attr('src') + '?autoplay=1');
    }
  });
})(jQuery);

(function ($) {
  var $coll = $('#js-room-ada');

  $coll.click(function () {
    $coll.toggleClass('active');
    $coll.next().toggleClass('hidden');
  });
})(jQuery);

(function ($) {
  var $learnMore = $('.js-learn-more');

  $learnMore.click(function () {
    $(this).siblings('.js-learn-more--trimmed-description').toggleClass('hidden');
    $(this).siblings('.js-learn-more--full-description').toggleClass('hidden');

    if ($(this).text() === 'Read More') {
      $(this).text('Read Less');
      $(this).toggleClass('read-less');
    } else {
      $(this).text('Read More');
      $(this).toggleClass('read-less');
    }
  });
})(jQuery);

(function ($, Drupal) {

  function isInViewport(el) {
    var rect = el.getBoundingClientRect();
    var extraScreen = 400; // THe Iframe is bigger than the parent page so its still loading 

    return rect.top < window.innerHeight && rect.left < window.innerWidth && rect.bottom > 0 - extraScreen && rect.right > 0;
  }

  var VimeoAutoPause = function () {
    function VimeoAutoPause(iframe) {
      _classCallCheck(this, VimeoAutoPause);

      this.type = "vimeo";
      this.iframe = iframe;
      this.vim = new Vimeo.Player(iframe);
      this.autoPaused = false;
    }

    _createClass(VimeoAutoPause, [{
      key: 'ready',
      value: function ready(callback) {
        var self = this;

        self.setup();
        callback();
      }
    }, {
      key: 'setup',
      value: function setup() {
        var self = this;
        this.iframe._autoPause = this; // Set the object in the dom so it can be grabbed later
        this.vim.on('timeupdate', function () {
          if (!document.hasFocus() || !isInViewport(this.iframe)) {
            self.pause();
          }
        });

        window.addEventListener('focus', function () {
          if (isInViewport(self.iframe)) {
            self.play();
          }
        });
      }
    }, {
      key: 'play',
      value: function play() {
        if (this.autoPaused) {
          this.vim.play();
          this.autoPaused = false;
        }
      }
    }, {
      key: 'pause',
      value: function pause() {
        var self = this;
        this.vim.getPaused().then(function (paused) {
          if (!paused) {
            self.vim.pause();
            self.autoPaused = true;
          }
        });
      }
    }]);

    return VimeoAutoPause;
  }();

  Drupal.behaviors.autoPauseVideo = {
    initialized: false,

    attach: function attach(contenxt, settings) {
      if (!this.initialized) {
        this.initialized = true;
        this.init(contenxt, settings);
      }
    },

    init: function init(contenxt, settings) {
      var self = this;
      if (!!window.IntersectionObserver) {
        var iframes = document.querySelectorAll("iframe");
        var players = [];

        iframes.forEach(function (iframe) {

          var player;
          if (iframe.src.match(/player.vimeo\.com/)) {
            player = new VimeoAutoPause(iframe);
          }

          if (typeof player !== "undefined") {
            players.push(player);
          }
        });

        var Interobserver = new IntersectionObserver(function (entries, observer) {
          entries.forEach(function (entry) {

            var player = entry.target._autoPause;
            if (!entry.isIntersecting) {
              player.pause();
            } else if (player.autoPaused) {
              player.play();
            }
          });
        }, { threshold: 0 });

        players.forEach(function (player) {
          player.ready(function () {
            Interobserver.observe(player.iframe);
          });
        });
      }
    }
  };
})(jQuery, Drupal);

// Header Toggle
(function ($) {
  $('.faq--header-toggle').click(function (e) {

    if ($(this).data('closesiblings')) {
      $(".faq--header-toggle").not(this).removeClass('active').attr("aria-expanded", false);
      $(".faq--header-toggle").not(this).siblings('.faq--wrapper').slideUp();
    }

    $(".faq--question").removeClass('active').attr("aria-expanded", false);
    $('.faq--answer-wrapper').slideUp();

    $(this).toggleClass('active');
    $(this).siblings('.faq--wrapper').slideToggle();

    if ($(this).hasClass('active')) {
      $(this).attr("aria-expanded", true);
    } else {
      $(this).attr("aria-expanded", false);
    }
  });
})(jQuery);

// FAQ Toggle
(function ($) {
  $('.faq--question').click(function (e) {
    e.stopPropagation();

    if ($(this).data('closesiblings')) {
      $(".faq--question").not(e.target).removeClass('active').attr("aria-expanded", false);
      $(".faq--question").not(e.target).siblings('.faq--answer-wrapper').slideUp();
    }

    $(this).toggleClass('active');
    $(this).siblings('.faq--answer-wrapper').slideToggle();

    if ($(this).hasClass('active')) {
      $(this).attr("aria-expanded", true);
    } else {
      $(this).attr("aria-expanded", false);
    }
  });
})(jQuery);